<div *ngIf="!loading" provide-parent-form>
	
	<h3>{{ 'PLAYBACK_PREFERENCES' | translate }}</h3>

	<bb-form-element [label]="'SKIN_BEHAVIOUR' | translate" [helpMessage]="'HELP.SKIN_BEHAVIOUR' | translate" [hasPublicationField]="'skinBehaviour'">
		<bb-select name="playout-skinBehaviour" [(ngModel)]="playout.skinBehaviour" [options]="skinOptions"></bb-select>
	</bb-form-element>
	
	<bb-form-element [label]="'CUSTOM_SKIN_PATH' | translate" [hasPublicationField]="'customSkinPath'">
		<input name="playout-customSkinPath" type="text" [(ngModel)]="playout.customSkinPath" (blur)="loadCustomSkin()" />
	</bb-form-element>

	<bb-form-element [label]="'NATIVE_CONTROLS' | translate" [helpMessage]="'HELP.NATIVE_CONTROLS' | translate" [hasPublicationField]="'nativeControls'">
		<bb-check name="playout-nativeControls" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.nativeControls"></bb-check>
	</bb-form-element>

	<bb-form-element [label]="'ISOLATE_PLAYER_STYLING' | translate" [helpMessage]="'HELP.ISOLATE_PLAYER_STYLING' | translate" [hasPublicationField]="'isolatePlayer'">
		<bb-check name="playout-isolatePlayer" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.isolatePlayer"></bb-check>
	</bb-form-element>
	
	<bb-form-element [label]="'YOUTUBE_HOSTING' | translate" [helpMessage]="'HELP.YOUTUBE_HOSTING' | translate" [hasPublicationField]="'youTubeHosting'">
		<bb-check name="playout-youTubeHosting" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.youTubeHosting"></bb-check>
	</bb-form-element>
	
	<bb-form-element [label]="'YOUTUBE_SKIN_IN_MAIN_PHASE' | translate" [helpMessage]="'HELP.YOUTUBE_SKIN_IN_MAIN_PHASE' | translate" [hasPublicationField]="'youTubeSkinInMainPhase'" [hidden]="playout.youTubeHosting !== 'true'">
		<bb-check name="playout-youTubeSkinInMainPhase" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.youTubeSkinInMainPhase"></bb-check>
	</bb-form-element>
	
	<bb-form-element [label]="'FORCE_NATIVE_FULLSCREEN' | translate" [helpMessage]="'HELP.FORCE_NATIVE_FULLSCREEN' | translate" [hasPublicationField]="'forceNativeFullscreen'" *ngIf="playout.avoidNativeFullscreen !== 'true'">
		<bb-check name="playout-forceNativeFullscreen" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.forceNativeFullscreen"></bb-check>
	</bb-form-element>

	<bb-form-element [label]="'DISABLE_STATISTICS_LOGGING' | translate" [helpMessage]="'HELP.DISABLE_STATISTICS_LOGGING' | translate" [hasPublicationField]="'noStats'">
		<bb-check name="playout-noStats" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.noStats"></bb-check>
	</bb-form-element>

	<bb-form-element [label]="'PREFER_HD' | translate" [helpMessage]="'HELP.PREFER_HD' | translate">
		<bb-check name="playout-preferHD" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.preferHD"></bb-check>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'LEADER' | translate">
		<bb-logo-selector [useType]="'commercial'" [mediaTypes]="['video']" [(entityId)]="leaderPositionId" (entityIdChange)="changePlayoutLeaderLogo(leaderPositionId)"></bb-logo-selector>
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'TIMELINE_ID' | translate" [hasPublicationField]="'playoutTimelineId'">
		<input name="playout-timelineId" type="text" [(ngModel)]="playout.timelineId" />
	</bb-form-element>

	<bb-form-element [form]="form" [label]="'INTERACTIVE_TEMPLATE' | translate" [hasPublicationFieldOrPermission]="'playoutTemplate'">
		<bb-entity-selector [entityType]="'app'" [(ngModel)]="playout.templateId" name="templateId"></bb-entity-selector>
	</bb-form-element>
	
	<div *ngIf="showLanguages">
		<h3>{{ "LANGUAGES" | translate }}</h3>

		<bb-form-element [label]="'DEFAULT_SUBTITLE' | translate" [helpMessage]="'HELP.PLAYOUT_DEFAULT_LANGUAGE' | translate">
			<bb-select name="playout-defaultSubtitle" [(ngModel)]="playout.defaultSubtitle" [options]="defaultSubtitleOptions"></bb-select>
		</bb-form-element>

		<bb-form-element [label]="'ONLY_WHEN_MUTED' | translate" [helpMessage]="'HELP.PLAYOUT_ONLY_WHEN_MUTED' | translate" *ngIf="playout.defaultSubtitle === 'First Available Subtitle' || playout.defaultSubtitle === 'Default Language'">
			<bb-check name="playout-onlyWhenMuted" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.defaultSubtitleOnlyIfMuted"></bb-check>
		</bb-form-element>

		<bb-form-element [label]="'DEFAULT_AUDIO_TRACK' | translate" [helpMessage]="'HELP.PLAYOUT_DEFAULT_LANGUAGE' | translate">
			<bb-select name="playout-defaultAudioTrack" [(ngModel)]="playout.defaultAudioTrack" [options]="defaultAudiotrackOptions"></bb-select>
		</bb-form-element>
	</div>

	<h3>{{ "DEVELOPER_OPTIONS" | translate }}</h3>
	
	<bb-form-element [label]="'URL_COMSCORE_LOGGING' | translate">
		<input name="playout-nedStatLoggerUrl" type="text" [(ngModel)]="playout.nedStatLoggerUrl" />
	</bb-form-element>

	<bb-form-element [label]="'DISABLE_JSONLD_TAGGING' | translate" [helpMessage]="'HELP.DISABLE_JSONLD_TAGGING' | translate">
		<bb-check name="playout-taggingDisabled" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.taggingDisabled"></bb-check>
	</bb-form-element>

	<bb-form-element [label]="'PIWIK_URL' | translate" [hasPublicationField]="'piwikUrl'">
		<input name="playout-piwikUrl" type="text" [(ngModel)]="playout.piwikUrl" />
	</bb-form-element>
	
	<bb-form-element [label]="'PWIKI_SITE_ID' | translate" [hasPublicationField]="'piwikSiteId'">
		<input name="playout-piwikSiteId" type="text" [(ngModel)]="playout.piwikSiteId" />
	</bb-form-element>

	<bb-form-element [label]="'COOKIES' | translate" [helpMessage]="'HELP.PLAYOUT_COOKIES' | translate">
		<bb-select name="playout-disableCookies" [(ngModel)]="playout.disableCookies" [options]="disableCookieOptions"></bb-select>
	</bb-form-element>
	
	<bb-form-element [label]="'NPA_ONLY' | translate" [hasPublicationField]="'restriction_npaOnly'">
		<bb-check name="playout-restriction_npaOnly" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.restriction_npaOnly"></bb-check>
	</bb-form-element>
	
	<bb-form-element [label]="'NPC_ONLY' | translate" [hasPublicationField]="'restriction_npcOnly'">
		<bb-check name="playout-restriction_npcOnly" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.restriction_npcOnly"></bb-check>
	</bb-form-element>
	
	<bb-form-element [label]="'SUPPORT_IAB_CONSENT' | translate" [helpMessage]="'HELP.PLAYOUT_SUPPORT_IAB_CONSENT' | translate" [hasPublicationField]="'supportIABConsent'">
		<bb-check name="playout-supportIABConsent" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.supportIABConsent"></bb-check>
	</bb-form-element>
	
	<div [hasPublicationField]="'googleAnalyticsId'">

		<h3>{{ "GOOGLE_ANALYTICS" | translate }}</h3>
	
		<bb-form-element [label]="'GOOGLE_ANALYTICS_ID' | translate">
			<input name="playout-googleAnalyticsId" type="text" [(ngModel)]="playout.googleAnalyticsId" />
		</bb-form-element>

		<bb-form-element [label]="'GOOGLE_ANALYTICS_CUSTOM_VARS' | translate" [helpMessage]="'HELP.GOOGLE_ANALYTICS_CUSTOM_VARS' | translate">
			<input name="playout-googleAnalytics_customVars" type="text" [(ngModel)]="playout.googleAnalytics_customVars" />
		</bb-form-element>
	</div>

	<div [hasPublicationField]="'googleTagManagerLogging'">
		<h3>{{ "GOOGLE_TAG_MANAGER" | translate }}</h3>

		<bb-form-element [label]="'GOOGLE_TAG_MANAGER_ID' | translate">
			<input name="playout-googleTagManagerId" type="text" [(ngModel)]="playout.googleTagManagerId" />
		</bb-form-element>
	</div>

	<div [hasPublicationField]="'disableContextMenuNavigate OR playerSignature OR playerSignatureLink'">
		<h3>{{ "CONTEXT_MENU" | translate }}</h3>

		<bb-form-element [label]="'CONTEXT_MENU_NAVIGATE' | translate" [hasPublicationField]="'disableContextMenuNavigate'">
			<bb-check name="playout-disableContextMenuNavigate" [trueValue]="'true'" [falseValue]="'false'" [(ngModel)]="playout.disableContextMenuNavigate"></bb-check>
		</bb-form-element>

		<bb-form-element [label]="'PLAYER_SIGNATURE' | translate" [hasPublicationField]="'playerSignature'">
			<input name="playout-playerSignature" type="text" [(ngModel)]="playout.playerSignature" />
		</bb-form-element>

	</div>

	<bb-form-element [label]="'PLAYER_SIGNATURE_URL' | translate" [hasPublicationField]="'playerSignatureLink'">
		<input name="playout-playerSignatureLink" type="text" [(ngModel)]="playout.playerSignatureLink" />
	</bb-form-element>
</div>
